/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/ProjectMembersStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreLoadingState } from "TFS/Views/ProjectOverviewPage/Shared/Contracts";
import { MemberInfo, MembersData } from "TFS/Views/ProjectOverviewPage/Shared/Models";

export interface ProjectMembersStoreState {
    loadingState: StoreLoadingState;
    membersToDisplay: MemberInfo[];
    errorMessage: string;
    membersCount: number;
    hasMore: boolean;
}

export class ProjectMembersStore extends Store {
    private _state: ProjectMembersStoreState = {
        loadingState: StoreLoadingState.Loading,
        membersToDisplay: [],
        errorMessage: "",
        membersCount: 0,
        hasMore: false
    };

    public getState = (): ProjectMembersStoreState => {
        return this._state;
    };

    public loadMembersInfo = (membersInfo: MembersData): void => {
        this._state.membersToDisplay = membersInfo.members;
        this._state.membersCount = membersInfo.count;
        this._state.hasMore = membersInfo.hasMore;

        this._state.loadingState = StoreLoadingState.Loaded;

        this.emitChanged();
    };

    public loadMembersInfoFailed = (message: string): void => {
        this._state.errorMessage = message;

        this._state.loadingState = StoreLoadingState.LoadFailed;

        this.emitChanged();
    };
}
